export default [
  {
    path: '/course/video',
    name: 'course_video',
    meta: {
      title: '孕橙视频'
    },
    component: () => import('views/course/video')
  },
  {
    path: '/course/video/more/:id',
    name: 'course_video_more',
    meta: {
      title: '更多视频'
    },
    component: () => import('views/course/video/more')
  },
  {
    path: '/course/group/more/:id',
    name: 'course_group_more',
    meta: {
      title: '...'
    },
    component: () => import('views/course/group/more')
  },
  {
    path: '/course/video/more',
    name: 'course_video_more_id',
    meta: {
      title: '更多视频'
    },
    component: () => import('views/course/video/more')
  },
  {
    path: '/course/video/show/:id',
    name: 'course_video_show',
    meta: {
      title: '视频播放'
    },
    component: () => import('views/course/video/show')
  },
  {
    path: '/course/video/search',
    name: 'course_video_search',
    meta: {
      title: '搜索'
    },
    component: () => import('views/course/video/search')
  },
  {
    path: '/course/article/m_list',
    name: 'course_article_m_list',
    meta: {
      title: '孕橙文章'
    },
    component: () => import('views/course/article/m_list')
  },
  {
    path: '/course/article/pc_list',
    name: 'course_article_pc_list',
    meta: {
      title: '孕橙科普'
    },
    component: () => import('views/course/article/pc_list')
  },
]